import { render, staticRenderFns } from "./month-picker.vue?vue&type=template&id=0af8caec&"
import script from "./month-picker.vue?vue&type=script&lang=ts&"
export * from "./month-picker.vue?vue&type=script&lang=ts&"
import style0 from "./month-picker.vue?vue&type=style&index=0&id=0af8caec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports